export const compactUrlValues = (values = {}) => Object.keys(values).reduce((result, key) => {
  const value = values[key];
  const invalidLiteral = value === 'undefined' || value === 'null';
  const emptyArray = Array.isArray(value) && value.length === 0;
  if (value !== undefined && value !== null && value !== '' && !invalidLiteral && !emptyArray) {
    result[key] = value;
  }
  return result;
}, {});
